import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import NotFound404 from '../../../components/NotFound404'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { useAppDispatch, useAppSelector } from '../../../store'
import { AppState, clearPhoneInfo } from '../../../store/appSlice'
import { TravelAbroadState, setSingleOrMulti } from '../../../store/travelAbroadSlice'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { Helmet } from 'react-helmet-async'
//
//
const SingleOrMulti = () => {
  //
  const dispatch = useAppDispatch()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { filter, screenHeader } = useAppSelector((data: { travelAbroad: TravelAbroadState }) => data.travelAbroad)
  //
  // insurance kinds
  const { data: insuranceKinds, isLoading: isInsuranceKindsLoading } = api.useGetInsuranceKindsQuery(undefined)
  // get product package min price single & multi
  const { data: TravelSingleOrMultiPrice, isLoading: isTravelSingleOrMultiPriceLoading } =
    api.useGetTravelSingleOrMultiPriceQuery(undefined)
  //
  //
  //
  const DataFropApi = insuranceKinds && TravelSingleOrMultiPrice
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  const [getLeftCompanies, { data: leftCompanies }] = api.useTravelAbrodLeftCompaniesMutation()
  //
  useEffect(() => {
    if (filter.productCategory && filter.singleOrMulti) {
      const GetCompaniesFunction = async () => {
        try {
          await getLeftCompanies({
            step: 'step-one',
            productCategory: filter.productCategory,
            travelType: filter.singleOrMulti,
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (getLeftCompanies) (SingleOrMulti)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [filter.singleOrMulti, filter.productCategory, getLeftCompanies])
  //
  //
  //
  const MainLoading = isTravelSingleOrMultiPriceLoading || isInsuranceKindsLoading
  //
  //
  return MainLoading ? (
    <Loader />
  ) : !DataFropApi ? (
    <NotFound404 />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('singleOrMultiTitle')}</title>
        <meta name="description" content={`${t('singleOrMultiTitle')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('singleOrMultiTitle')} />

        <AbroadProgressBar stepName={`${t('singleMulti')}`} />

        <InnerContainer>
          <Cards>
            {insuranceKinds &&
              insuranceKinds?.map((item, index) => {
                const mainPrice =
                  TravelSingleOrMultiPrice.multiInfo.type === item.type
                    ? TravelSingleOrMultiPrice.multiInfo.minPrice
                    : TravelSingleOrMultiPrice.singleInfo.type === item.type
                    ? TravelSingleOrMultiPrice.singleInfo.minPrice
                    : '0'
                //
                return (
                  <HorizontalCard
                    className="horizontal-card"
                    key={index}
                    saleText={mainPrice ? `${mainPrice} ₾ ${t('from')}` : ''}
                    title={item?.translations?.[lang]?.title || ''}
                    description={item?.translations?.[lang]?.body || ''}
                    imgUrl={item?.image}
                    selected={item.type === filter.singleOrMulti ? true : false}
                    onClick={() => dispatch(setSingleOrMulti(item.type))}
                  />
                )
              })}
          </Cards>
          <RemainingCompanies
            style={{
              opacity: leftCompanies ? '1' : '0',
            }}
            text={`${t('offerAvailable')}: ${leftCompanies?.length} `}
          />
        </InnerContainer>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/category')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            onClick={() => [
              dispatch(clearPhoneInfo()),
              filter.singleOrMulti === 'single-travel'
                ? navigate('/single-select-date')
                : navigate('/multi-select-date'),
            ]}
            disabled={
              filter.singleOrMulti && filter.productCategory && leftCompanies && leftCompanies.length >= 1
                ? false
                : true
            }
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const InnerContainer = styled.div`
  max-width: 464px;
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;

  .horizontal-card {
    &:first-child {
      margin-bottom: 24px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    .horizontal-card {
      margin-bottom: 20px;
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
export default SingleOrMulti
